module.exports = __webpack_public_path__ + "img/goal-fifteen-br.043a6d54.png";